export enum CardStyle {
  Default,
  IncompleteProduct,
  Location,
  QuickAction,
  ThemePreview,
  ThemeCarouselImage
}
